module.exports = __webpack_public_path__ + "public/img/xcs-1.b52b6185.jpg";